module.exports = __webpack_public_path__ + "static/insallationspartner-hero@2x-min-243bbefc0dca44e071804ce8fb12ca77.png";